import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CampaignCta from "@/components/CampaignCta";
import { Button } from "@/components/ui/button";
import { RESOURCE_ASSETS, type ResourceAsset } from "@/config/resources";

interface ResourceThankYouPageProps {
  assetId: ResourceAsset["id"];
}

/**
 * Post-submit thank-you page that serves the PDF download link.
 * SCAFFOLDED — downloadUrl is a placeholder until the real PDF is provided.
 */
const ResourceThankYouPage = ({ assetId }: ResourceThankYouPageProps) => {
  const asset = RESOURCE_ASSETS[assetId];

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      <main className="flex-grow">
        <section className="py-16 md:py-24">
          <div className="container mx-auto px-6 max-w-2xl text-center">
            <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground">
              Thanks — your guide is ready.
            </h1>
            <p className="mt-4 text-lg text-muted-foreground">
              {asset.title}
            </p>
            <div className="mt-8 flex flex-wrap gap-3 justify-center">
              {/* TODO: replace with provided PDF */}
              <Button asChild size="lg">
                <a href={asset.downloadUrl} target="_blank" rel="noopener noreferrer">
                  Download the PDF
                </a>
              </Button>
              <CampaignCta
                location={`resource-${asset.id}-thankyou`}
                variant="outline"
              >
                Start free 14-day trial
              </CampaignCta>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ResourceThankYouPage;
